<template>
  <div>
    <div class="toolbar">
      <el-input v-model="keyword" clearable placeholder="姓名/电话/备注" style="width:220px" @keyup.enter.native="load" />
      <el-select v-model="bannerId" clearable filterable placeholder="活动" style="width:220px" @change="load">
        <el-option v-for="b in banners" :key="b.id" :label="b.title" :value="b.id" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
    </div>
    <el-table :data="list" border stripe v-loading="loading">
      <el-table-column type="index" label="#" width="50" />
      <el-table-column prop="bannerTitle" label="活动" min-width="160" />
      <el-table-column prop="consulterName" label="咨询人" width="100" />
      <el-table-column prop="consulterTel" label="电话" width="130" />
      <el-table-column prop="consulterAddress" label="地址" min-width="140" show-overflow-tooltip />
      <el-table-column prop="houseType" label="房型" width="100" />
      <el-table-column prop="area" label="面积" width="90" />
      <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip />
      <el-table-column prop="miniNickname" label="微信昵称" width="110" />
      <el-table-column prop="createdAt" label="报名时间" width="170" />
      <el-table-column label="操作" width="90" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" style="color:#f56c6c" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { listBanners, listSignups, deleteSignup } from '../../api/cms'

export default {
  name: 'CmsSignup',
  data() {
    return {
      list: [],
      banners: [],
      loading: false,
      keyword: '',
      bannerId: null
    }
  },
  created() {
    this.loadBanners()
    this.load()
  },
  methods: {
    async loadBanners() {
      try {
        const res = await listBanners()
        this.banners = res.data || []
      } catch (e) {
        this.banners = []
      }
    },
    async load() {
      this.loading = true
      try {
        const res = await listSignups({
          keyword: this.keyword || undefined,
          bannerId: this.bannerId || undefined
        })
        this.list = res.data || []
      } finally {
        this.loading = false
      }
    },
    remove(row) {
      this.$confirm('确定删除该报名记录？', '提示', { type: 'warning' })
        .then(async () => {
          await deleteSignup(row.id)
          this.$message.success('已删除')
          this.load()
        })
        .catch(() => {})
    }
  }
}
</script>
